import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { ApiRequestDescriptor, executeQuery } from '../../services';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.carrier}carriers/files/${COMMON_QUERY_PARAMS.FILE_ID}/urls/${COMMON_QUERY_PARAMS.MODULE_DEFINITION_ID}/${COMMON_QUERY_PARAMS.MODULE_INSTANCE_ID}`;

interface GetCarrierLabelUrlQueryArgs {
  fileId: string;
  moduleDefinitionId: string;
  moduleInstanceId: string;
}

export const getCarrierLabelUrlRequest = ({
  fileId,
  moduleDefinitionId,
  moduleInstanceId,
}: GetCarrierLabelUrlQueryArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId)
    .replace(COMMON_QUERY_PARAMS.MODULE_DEFINITION_ID, moduleDefinitionId)
    .replace(COMMON_QUERY_PARAMS.MODULE_INSTANCE_ID, moduleInstanceId),
  config: { method: SUPPORTED_METHODS.GET },
});

const getCarrierLabelUrlQuery = async (
  payload: GetCarrierLabelUrlQueryArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      getCarrierLabelUrlRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getCarrierLabelUrlQuery;
